module.exports = __webpack_public_path__ + "resources/img/bg_banner_tcc_m_origin.273d43b5cc51c83ecd6a3289f3149bb3.jpg";